import { computed } from 'vue'
import { defineStore } from 'pinia'
import { ssrHtml } from '@/content'

/**
 * Etat minimal de la page : le content_html de la page courante uniquement.
 * Rempli au SSR depuis la map complete, serialise par vite-ssg (initialState),
 * puis relu tel quel a l'hydratation cote client : aucune divergence possible avec
 * le HTML pre-rendu, et le bundle client ne transporte pas les 5 Mo de contenu.
 */
export const usePageStore = defineStore('page', {
  state: () => ({ html: '' }),
})

export function useContentHtml(path: string) {
  const store = usePageStore()
  if (import.meta.env.SSR) {
    store.html = ssrHtml(path)
  }
  return computed(() => store.html)
}
